import { Navigate, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { useUser } from '../../../redux/user/useUser';

import { LpAdHeader } from './organisms/ad/LpAdHeader';
import { LpAdFv } from './organisms/ad/LpAdFv';
import { LpAdSuccessStory } from './organisms/ad/LpAdSuccessStory';
import { LpAdProgram } from './organisms/ad/LpAdProgram';
import { LpFeature } from './organisms/LpFeature';
import { LpAdLeadSimple } from './organisms/ad/LpAdLeadSimple';
import { LpAdLesson } from './organisms/ad/LpAdLesson';
import { LpAdProgramSampleList } from './organisms/ad/LpAdProgramSampleList';
import { LpAdCareerSupport } from './organisms/ad/LpAdCareerSupport';
import { LpAdQuestion } from './organisms/ad/LpAdQuestion';
import { LpAdStudyFlow } from './organisms/ad/LpAdStudyFlow';
import { LpAdRank } from './organisms/ad/LpAdRank';
import { LpAdUserVoice } from './organisms/ad/LpAdUserVoice';
import { LpAdPrice } from './organisms/ad/LpAdPrice';
import { LpAdMedia } from './organisms/ad/LpAdMedia';
import { LpAdPlan } from './organisms/ad/LpAdPlan';
import { LpAdLead } from './organisms/ad/LpAdLead';
import { LpFooter } from './organisms/LpFooter';
import { LpAdFloatBanner } from './organisms/ad/LpAdFloatBanner';
import { LpAdPopup } from './organisms/ad/LpAdPopup';
import { FunctionType, PermissionType } from '../../../const/UserPermission';
import { LpAdChallenge } from './organisms/ad/LpAdChallenge';
import { sessionStorageSupport } from '../../../utils/sessionStorageSupport';
import { useGoogleFonts } from '../../../common/customHooks/GoogleFonts';
import { LpAdFaq } from './organisms/ad/LpAdFaq';

export const LpAd: React.FC = () => {
  const { canAccess, cvLink } = useLpAd();

  if (!canAccess) {
    return <Navigate to="/home" replace />;
  }

  return (
    <>
      <LpAdHeader onClickCV={cvLink} />
      <LpAdFv onClickCV={cvLink} />
      <LpAdSuccessStory />
      <LpAdProgram />
      <LpAdLeadSimple onClickCV={cvLink} />
      <LpFeature title={'サービスの特徴'} id="feature" dataE2e="feature" />
      <LpAdPrice />
      <LpAdLesson />
      <LpAdProgramSampleList />
      <LpAdChallenge />
      <LpAdCareerSupport />
      <LpAdQuestion />
      <LpAdStudyFlow />
      <LpAdRank onClickCV={cvLink} />
      <LpAdUserVoice />
      <LpAdPlan />
      <LpAdMedia />
      <LpAdLead onClickCV={cvLink} />
      <LpAdFaq />
      <LpFooter />
      <LpAdFloatBanner onClickCV={cvLink} />

      <LpAdPopup />
    </>
  );
};

const useLpAd = () => {
  const { permissionCheck } = useUser();
  const location = useLocation();
  const navigate = useNavigate();
  useGoogleFonts();

  const query = queryString.parse(location.search);
  if (query.utm_source) {
    sessionStorageSupport.setItem('UTM_SOURCE', String(query.utm_source));
  }

  const cvLink = () => {
    navigate('/register');
  };

  const canAccess = permissionCheck(FunctionType.LP, PermissionType.Read);

  return { canAccess, cvLink };
};
